import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SAM_BASIC_01_Schema } from './SAM_BASIC_01_Schema';

/**
 * 작업계획서 기본정보(SAM_BASIC_01) 관련 React Query 훅 모음
 * - 기본 조회(useQuery): useSearch1
 * - 삭제/저장(useMutation 기반): useDelete1, useSave1
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SAM_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['SafetyWorkManagement', 'getSamBasic01R1', params],
    queryFn: () =>
      apiRequest(
        'post',
        Global.urls.SafetyWorkManagement.getSamBasic01R1,
        params
      ),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAM_BASIC_01_Schema.mapper.delete1);

    return apiRequest(
      'post1',
      Global.urls.SafetyWorkManagement.deleteSamBasic01D1,
      payload
    );
  }, options);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAM_BASIC_01_Schema.mapper.save1);

    return apiRequest(
      'post1',
      Global.urls.SafetyWorkManagement.saveSamBasic01U1,
      payload
    );
  }, options);
};
